export const config = {
  ONGOING_POLICY_CAR: {
    heading: 'This car is already insured by us',
    subHeading: 'How would you like to continue?',
    notLoggedSubHeading: lastDigits => `Log in with the mobile number xx${lastDigits} to access your policy`,
    primaryCtaText: 'View policy',
    secondaryCtaText: 'Edit registration number',
    iconSrc: 'https://acko-cms.ackoassets.com/Car_insurance_b81a214970.svg',
    iconAlt: 'Car insurance icon',
  },
  ONGOING_POLICY_BIKE: {
    heading: 'This bike is already insured by us',
    subHeading: 'How would you like to continue?',
    notLoggedSubHeading: lastDigits => `Log in with the mobile number xx${lastDigits} to access your policy`,
    primaryCtaText: 'View policy',
    secondaryCtaText: 'Edit registration number',
    iconSrc: 'https://acko-cms.ackoassets.com/Bike_insurance_1ffc08bb68.svg',
    iconAlt: 'Bike Insurance icon',
  },
  CAR_EXPIRED: {
    heading: 'This car’s ACKO policy has expired',
    subHeading: 'How would you like to continue?',
    notLoggedSubHeading: lastDigits => `Log in with the mobile number xx${lastDigits} to renew your policy`,
    primaryCtaText: 'Renew policy',
    secondaryCtaText: 'Edit registration number',
    iconSrc: 'https://acko-cms.ackoassets.com/Car_insurance_b81a214970.svg',
    iconAlt: 'Car insurance icon',
  },
  BIKE_EXPIRED: {
    heading: 'This bike’s ACKO policy has expired',
    subHeading: 'How would you like to continue?',
    notLoggedSubHeading: lastDigits => `Log in with the mobile number xx${lastDigits} to renew your policy`,
    primaryCtaText: 'Renew policy',
    secondaryCtaText: 'Edit registration number',
    iconSrc: 'https://acko-cms.ackoassets.com/Bike_insurance_1ffc08bb68.svg',
    iconAlt: 'Bike Insurance icon',
  },
  CAR_EXPIRING: {
    heading: 'This car’s ACKO policy is about to expire',
    subHeading: 'How would you like to continue?',
    notLoggedSubHeading: lastDigits => `Log in with the mobile number xx${lastDigits} to renew your policy`,
    primaryCtaText: 'Renew policy',
    secondaryCtaText: 'Edit registration number',
    iconSrc: 'https://acko-cms.ackoassets.com/Car_insurance_b81a214970.svg',
    iconAlt: 'Car insurance icon',
  },
  BIKE_EXPIRING: {
    heading: 'This bike’s ACKO policy is about to expire',
    subHeading: 'How would you like to continue?',
    notLoggedSubHeading: lastDigits => `Log in with the mobile number xx${lastDigits} to renew your policy`,
    primaryCtaText: 'Renew policy',
    secondaryCtaText: 'Edit registration number',
    iconSrc: 'https://acko-cms.ackoassets.com/Bike_insurance_1ffc08bb68.svg',
    iconAlt: 'Bike Insurance icon',
  },
  USER_BLOCKED_POLICY_ONGOING_CAR: {
    heading: 'This car is already insured by us',
    subHeading:
      "Thank you for your trust in ACKO. Due to recent changes in our offerings, we're unable to provide the right protection for your vehicle this year",
    notLoggedSubHeading: lastDigits =>
      "Thank you for your trust in ACKO. Due to recent changes in our offerings, we're unable to provide the right protection for your vehicle this year",
    primaryCtaText: 'View policy',
    secondaryCtaText: 'Edit registration number',
    iconSrc: 'https://acko-cms.ackoassets.com/Car_insurance_b81a214970.svg',
    iconAlt: 'Car insurance icon',
  },
  USER_BLOCKED_POLICY_ONGOING_BIKE: {
    heading: 'This bike is already insured by us',
    subHeading:
      "Thank you for your trust in ACKO. Due to recent changes in our offerings, we're unable to provide the right protection for your vehicle this year",
    notLoggedSubHeading: lastDigits =>
      "Thank you for your trust in ACKO. Due to recent changes in our offerings, we're unable to provide the right protection for your vehicle this year",
    primaryCtaText: 'View policy',
    secondaryCtaText: 'Edit registration number',
    iconSrc: 'https://acko-cms.ackoassets.com/Bike_insurance_1ffc08bb68.svg',
    iconAlt: 'Bike Insurance icon',
  },
  USER_BLOCKED_POLICY_EXPIRING_CAR: {
    heading: 'This car’s ACKO policy is about to expire',
    subHeading:
      "Thank you for your trust in ACKO. Due to recent changes in our offerings, we're unable to provide the right protection for your vehicle this year",
    notLoggedSubHeading: lastDigits =>
      "Thank you for your trust in ACKO. Due to recent changes in our offerings, we're unable to provide the right protection for your vehicle this year",
    primaryCtaText: 'View policy',
    secondaryCtaText: 'Edit registration number',
    iconSrc: 'https://acko-cms.ackoassets.com/Car_insurance_b81a214970.svg',
    iconAlt: 'Car insurance icon',
  },
  USER_BLOCKED_POLICY_EXPIRING_BIKE: {
    heading: 'This bike’s ACKO policy is about to expire',
    subHeading:
      "Thank you for your trust in ACKO. Due to recent changes in our offerings, we're unable to provide the right protection for your vehicle this year",
    notLoggedSubHeading: lastDigits =>
      "Thank you for your trust in ACKO. Due to recent changes in our offerings, we're unable to provide the right protection for your vehicle this year",
    primaryCtaText: 'View policy',
    secondaryCtaText: 'Edit registration number',
    iconSrc: 'https://acko-cms.ackoassets.com/Bike_insurance_1ffc08bb68.svg',
    iconAlt: 'Bike Insurance icon',
  },
  USER_BLOCKED_POLICY_EXPIRED_CAR: {
    heading: 'This car’s ACKO policy has expired',
    subHeading:
      "Thank you for your trust in ACKO. Due to recent changes in our offerings, we're unable to provide the right protection for your vehicle this year",
    notLoggedSubHeading: lastDigits =>
      "Thank you for your trust in ACKO. Due to recent changes in our offerings, we're unable to provide the right protection for your vehicle this year",
    primaryCtaText: 'View policy',
    secondaryCtaText: 'Edit registration number',
    iconSrc: 'https://acko-cms.ackoassets.com/Car_insurance_b81a214970.svg',
    iconAlt: 'Car insurance icon',
  },
  USER_BLOCKED_POLICY_EXPIRED_BIKE: {
    heading: 'This bike’s ACKO policy has expired',
    subHeading:
      "Thank you for your trust in ACKO. Due to recent changes in our offerings, we're unable to provide the right protection for your vehicle this year",
    notLoggedSubHeading: lastDigits =>
      "Thank you for your trust in ACKO. Due to recent changes in our offerings, we're unable to provide the right protection for your vehicle this year",
    primaryCtaText: 'View policy',
    secondaryCtaText: 'Edit registration number',
    iconSrc: 'https://acko-cms.ackoassets.com/Bike_insurance_1ffc08bb68.svg',
    iconAlt: 'Bike Insurance icon',
  },
  CAR_MODEL_UNSERVICEABLE: {
    heading: 'Unfortunately, we are unable to cover you at this time',
    subHeading: 'We’re working towards expanding our coverage and will let you know when we’re ready',
    notLoggedSubHeading: lastDigits => `Log in with the mobile number xx${lastDigits} to access your policy`,
    primaryCtaText: 'OK',
    secondaryCtaText: null,
    iconSrc: 'https://acko-cms.ackoassets.com/Not_applicable_oops_sorry_bc1f29a1b1.svg',
    iconAlt: 'Not applicable icon',
  },
  BIKE_MODEL_UNSERVICEABLE: {
    heading: 'Unfortunately, we are unable to cover you at this time',
    subHeading: 'We’re working towards expanding our coverage and will let you know when we’re ready',
    notLoggedSubHeading: lastDigits => `Log in with the mobile number xx${lastDigits} to access your policy`,
    primaryCtaText: 'OK',
    secondaryCtaText: null,
    iconSrc: 'https://acko-cms.ackoassets.com/Not_applicable_oops_sorry_bc1f29a1b1.svg',
    iconAlt: 'Not applicable icon',
  },
  INSPECTION_DONE: {
    heading: 'An ACKO inspection has already been scheduled for this car',
    primaryCtaText: 'Track inspection status',
    secondaryCtaText: 'Edit registration number',
    subHeading: '',
    notLoggedSubHeading: lastDigits => `Log in with the mobile number xx${lastDigits} to know the status of inspection`,
    iconSrc: 'https://acko-cms.ackoassets.com/car_Inspection_progress_scheduled_undergoing_490540d002.svg',
    iconAlt: 'Car inspection progress icon',
  },
  INSPECTION_PENDING: {
    heading: 'An ACKO inspection needs to be scheduled for this car',
    primaryCtaText: 'Schedule inspection',
    secondaryCtaText: 'Edit registration number',
    subHeading: '',
    notLoggedSubHeading: lastDigits => `Log in with the mobile number xx${lastDigits} to schedule an inspection`,
    iconSrc: 'https://acko-cms.ackoassets.com/Vehicle_pre_inspection_car_077f261373.svg',
    iconAlt: 'Vehicle inspection progress icon',
  },
  MISMATCH_INSPECTION_DONE: {
    heading: 'Looks like this number belongs to a car, and an ACKO inspection has been scheduled for this car',
    primaryCtaText: 'Track inspection status',
    secondaryCtaText: 'Edit registration number',
    subHeading: 'How would you like to continue?',
    notLoggedSubHeading: lastDigits => `Log in with the mobile number xx${lastDigits} to know the status of inspection`,
    iconSrc: 'https://acko-cms.ackoassets.com/Alert_attention_caution_2_ada7fafd4c.svg',
    iconAlt: 'Alert icon',
  },
  MISMATCH_INSPECTION_PENDING: {
    heading: 'Looks like this number belongs to a car not a bike, and you need to schedule an ACKO inspection for it',
    primaryCtaText: 'Schedule inspection',
    secondaryCtaText: 'Edit registration number',
    subHeading: 'How would you like to continue?',
    notLoggedSubHeading: lastDigits => `Log in with the mobile number xx${lastDigits} to schedule an inspection`,
    iconSrc: 'https://acko-cms.ackoassets.com/Alert_attention_caution_2_ada7fafd4c.svg',
    iconAlt: 'Alert icon',
  },
}

export const segmentModalType = {
  ONGOING_POLICY_CAR: 'ONGOING_POLICY_CAR',
  ONGOING_POLICY_BIKE: 'ONGOING_POLICY_BIKE',
  CAR_EXPIRED: 'EXPIRED',
  BIKE_EXPIRED: 'EXPIRED',
  CAR_EXPIRING: 'EXPIRING',
  BIKE_EXPIRING: 'EXPIRING',
  USER_BLOCKED_POLICY_ONGOING_CAR: 'USER_BLOCKED_POLICY_ONGOING_CAR',
  USER_BLOCKED_POLICY_ONGOING_BIKE: 'USER_BLOCKED_POLICY_ONGOING_BIKE',
  USER_BLOCKED_POLICY_EXPIRING_CAR: 'USER_BLOCKED_POLICY_EXPIRING_CAR',
  USER_BLOCKED_POLICY_EXPIRING_BIKE: 'USER_BLOCKED_POLICY_EXPIRING_BIKE',
  USER_BLOCKED_POLICY_EXPIRED_CAR: 'USER_BLOCKED_POLICY_EXPIRED_CAR',
  USER_BLOCKED_POLICY_EXPIRED_BIKE: 'USER_BLOCKED_POLICY_EXPIRED_BIKE',
  CAR_MODEL_UNSERVICEABLE: '',
  BIKE_MODEL_UNSERVICEABLE: '',
  INSPECTION_DONE: 'INSPECTION_DONE',
  INSPECTION_PENDING: 'INSPECTION_PENDING',
  MISMATCH_INSPECTION_DONE: 'INSPECTION_DONE',
  MISMATCH_INSPECTION_PENDING: 'INSPECTION_PENDING',
}
